import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=76d03a1d&scoped=true&"
import script from "./tourist.vue?vue&type=script&lang=js&"
export * from "./tourist.vue?vue&type=script&lang=js&"
import style0 from "./tourist.vue?vue&type=style&index=0&id=76d03a1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d03a1d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/chofn/components/Header.vue').default})
